
<div class="h-screen "  [ng2-loading]="commonSrvc_.showSpinner">
  <router-outlet></router-outlet>
</div>
